import { AuthContext, IAuthContext } from 'react-oauth2-code-pkce'
import { useContext, useEffect, useRef } from 'react'
import { logMessage } from './Logging'

export function debugSetItem(prefix: string) {
  logMessage(`Debugging localStorage with prefix: ${prefix}`, 'debug', 'AuthDebug')
  const orig = localStorage.setItem

  localStorage.setItem = function (key: string, value: string): void {
    if (key.startsWith(prefix)) logMessage(`setItem: ${key} = ${value}`, 'debug', 'AuthDebug')
    return orig.apply(this, [key, value])
  }
}

export function debugRemoveItem(prefix: string) {
  logMessage(`Debugging localStorage removeItem with prefix: ${prefix}`, 'debug', 'AuthDebug')
  const orig = localStorage.removeItem

  localStorage.removeItem = function (key: string): void {
    if (key.startsWith(prefix)) logMessage(`removeItem: ${key}`, 'debug', 'AuthDebug')
    return orig.apply(this, [key])
  }
}

export function debugNetwork(tokenUrl: string) {
  logMessage(`Debugging network requests to URL: ${tokenUrl}`, 'debug', 'AuthDebug')
  const origFetch = window.fetch
  window.fetch = async (...args) => {
    const [url, init] = args
    if (typeof url === 'string' && url.startsWith(tokenUrl)) {
      logMessage(`fetch called with URL: ${url} and init: ${JSON.stringify(init)}`, 'debug', 'AuthDebug')
    }
    const res = await origFetch(...args)
    if (typeof url === 'string' && url.startsWith(tokenUrl)) {
      logMessage(`fetch response: ${res.status} ${res.statusText}`, 'debug', 'AuthDebug')
    }
    return res
  }
}

export function logAuthContext() {
  const authContext = useContext<IAuthContext>(AuthContext)
  const { error } = authContext
  useEffect(() => {
    if (error) {
      logMessage(`AuthContext error: ${error}`, 'error', 'AuthDebug')
    }
  }, [error])

  const prev = useRef<unknown>({})

  useEffect(() => {
    const snapshot = {
      loginInProgress: authContext.loginInProgress,
      tokenTail: authContext.token ? authContext.token.slice(-12) : null,
      exp: typeof authContext.tokenData?.exp === 'number' ? authContext.tokenData.exp : null,
      now: Math.floor(Date.now() / 1000),
      secondsLeft:
        typeof authContext.tokenData?.exp === 'number'
          ? authContext.tokenData.exp - Math.floor(Date.now() / 1000)
          : null,
      error: authContext.error,
      idTokenPresent: !!authContext.idToken,
    }

    const snapshotStr = JSON.stringify(snapshot)
    const changed = snapshotStr !== JSON.stringify(prev.current)
    if (changed) {
      logMessage(snapshotStr, 'debug', 'AuthDebug')
      prev.current = snapshot
    }
  }, [authContext])
}
